import {
  faUsers,
  faHandshake,
  faLaptopMedical,
  faCog,
  faPuzzlePiece,
  faClipboardList,
} from '@fortawesome/free-solid-svg-icons';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import type { SidebarCategory } from '@v2/components';

export interface SettingsRoute {
  path: string;
  label: string;
  icon: IconDefinition;
  description: string;
}

export const settingsRoutes: SettingsRoute[] = [
  {
    path: 'accounts',
    label: 'Accounts',
    icon: faUsers,
    description: 'Manage user accounts and access',
  },
  {
    path: 'partners',
    label: 'Partners',
    icon: faHandshake,
    description: 'Manage partner organizations',
  },
  {
    path: 'pims',
    label: 'Pims',
    icon: faLaptopMedical,
    description: 'Manage practice management systems',
  },
  {
    path: 'offerings',
    label: 'Bitwerx Offerings',
    icon: faCog,
    description: 'Configure Bitwerx product offerings',
  },
  {
    path: 'mission-control',
    label: 'Mission Control',
    icon: faPuzzlePiece,
    description: 'Manage plugins and versions',
  },
  {
    path: 'bulk-manifest',
    label: 'Bulk Manifest',
    icon: faClipboardList,
    description: 'Perform bulk manifest updates',
  },
];

export const settingsCategories: SidebarCategory[] = [
  {
    label: 'Settings',
    items: settingsRoutes.map(({ path, label, icon }) => ({ path, label, icon })),
  },
];
